import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaEsameNeurologicoIngressoEditComponent.vue?vue&type=template&id=0a1e9ab6"
import script from "./RsaSchedaRelazioneSanitariaEsameNeurologicoIngressoEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaEsameNeurologicoIngressoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports